const SELECTOR = '.js-video-toggle';

export function attachVideoToggles() {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll<HTMLButtonElement>(SELECTOR).forEach((toggle) => {
    const video = document.getElementById(toggle.getAttribute('aria-controls') ?? '');
    if (!(video instanceof HTMLVideoElement)) return;

    // Several component bundles call this on DOMContentLoaded and it scans the whole
    // document, so without this a toggle gets bound once per bundle and the handlers
    // cancel each other out.
    if (toggle.dataset.videoToggleBound === 'true') return;
    toggle.dataset.videoToggleBound = 'true';

    const sync = () => {
      toggle.classList.toggle('is-playing', !video.paused);
      toggle.setAttribute('aria-label', (video.paused ? toggle.dataset.labelPlay : toggle.dataset.labelPause) ?? '');
    };

    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    toggle.addEventListener('click', () => {
      if (video.paused) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });

    if (reduceMotion) {
      video.removeAttribute('autoplay');
      video.pause();
    }

    sync();
  });
}
